import React, { useEffect, useState } from 'react'
import NavigationBar from '../../components/Navigationbar/Navigationbar'
import { Autocomplete, Box, Button, Card, Dropdown, IconButton, Input, Menu, MenuButton, MenuItem, Tab, tabClasses, Table, TabList, TabPanel, Tabs, Typography } from '@mui/joy'
import Headline from '../../components/headline/Headline';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { FormControl, FormLabel } from '@mui/material';
import { post, Token, url } from '../../Script/Session';
import { useNavigate } from 'react-router-dom';
import MoreVert from '@mui/icons-material/MoreVert';
import { haspermission } from '../../Script/Permission';
function Protokolle() {
  const [wit, setWit] = useState("90.5%");
  const [beiratlongarray, setbeiratlongarray] = useState([]);
  const [tagungslongarray, settagungslongarray] = useState([]);
  const [data, setdata] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    let body = {};
    body.token = Token.get();
    body.action = "get";
    let response = post(body, "/protokolle/text");
    if (response == "LOGOUT") {
      navigate("/");
    }
    setdata(JSON.parse(response));
    setbeiratlongarray(JSON.parse(response)?.result?.slice().filter((a) => a.type == "Beirat").map(a => { return (a.date) }));
    settagungslongarray(JSON.parse(response)?.result?.slice().filter((a) => a.type == "Tagung").map(a => { return (a.date) }));
  }, []);


  function update() {
    let body = {};
    body.token = Token.get();
    body.action = "get";
    let response = post(body, "/protokolle/text");
    if (response == "LOGOUT") {
      navigate("/");
    }
    setdata(JSON.parse(response));
    setbeiratlongarray(JSON.parse(response)?.result?.slice().filter((a) => a.type == "Beirat").map(a => { return (a.date) }));
    settagungslongarray(JSON.parse(response)?.result?.slice().filter((a) => a.type == "Tagung").map(a => { return (a.date) }));
  }




  function hasTimestampForMonth(timestamps, year, month) {
    return timestamps.some(ts => {
      const date = new Date(ts);
      return date.getFullYear() === year && date.getMonth() === (month - 1);
    });
  }
  const [file, setfile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setfile(file);
      // Optional: weitere Verarbeitung, z. B. Upload starten
    }
  };
  const [selectedart, setselectedart] = useState();
  const [datum, setdatum] = useState();
  const [users, setusers] = useState();
  const [selecteduser, setselecteduser] = useState();
  useEffect(() => {
    let body = {};
    body.token = Token.get();
    let response = post(body, "/userlist");
    setusers(JSON.parse(response));
  }, []);
  const [index, setIndex] = React.useState(0);
  const addDatei = () => {
    if (!file) return;
    console.log("Uploading...");

    const formData = new FormData();
    const body = {
      token: Token.get(),
      action: "create",
      type: selectedart,
      date: datum,
      writer: selecteduser.id,
    };

    formData.append("json", JSON.stringify(body));
    formData.append("file", file);

    fetch(url + "/api/protokolle/create", {
      method: "POST",
      body: formData,
    })
      .then(res => res.text())
      .then(text => {
        console.log(text);
        if (text === "OK") {
          window.location.reload();
        }
      })
      .catch(console.error);
  };
  const [edittarget, seteditarget] = useState();
  const [editpanel, seteditpanel] = useState(false);
  const [eidtkath, seteditkath] = useState();
  const [editdatum, seteditdatum] = useState();
  const [editersteller, seteditersteller] = useState();
  function triggeredit(id, kath, editdatum, ersteller) {
    console.log("editmode");
    seteditarget(id);
    seteditkath(kath);
    seteditdatum(editdatum);
    seteditersteller(users?.result.find((a) => a.id == ersteller));
    seteditpanel(true);
  }
  function saveedit() {
    let body = {};
    body.token = Token.get();
    body.action = "edit";
    body.type = eidtkath;
    body.date = editdatum;
    body.writer = editersteller.id;
    body.target = edittarget;
    let response = post(body, "/protokolle/text");
    if (response == "LOGOUT") {
      navigate("/");
    }
    update();
    seteditpanel(false);
  }
  function deleteprotokoll(id) {
    let body = {};
    body.token = Token.get();
    body.action = "delete";
    body.target = id;
    let response = post(body, "/protokolle/text");
    if (response == "LOGOUT") {
      navigate("/");
    }
    console.log(response);
    update();
  }

  const [perm, hasperm] = useState(haspermission("28"))
  return (
    <>
      <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>
        <Headline title={"Protokolle"} />
        <Tabs sx={{ width: "100%" }} defaultValue={0}>
          <TabList
            sx={{
              pt: 1,
              justifyContent: 'center',
              [`&& .${tabClasses.root}`]: {
                flex: 'initial',
                bgcolor: 'transparent',
                '&:hover': {
                  bgcolor: 'transparent',
                },
                [`&.${tabClasses.selected}`]: {
                  color: 'primary.plainColor',
                  '&::after': {
                    height: 2,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    bgcolor: 'primary.500',
                  },
                },
              },
            }}
          >
            <Tab variant="soft" color="neutral">Beirat</Tab>
            <Tab variant="soft" color="neutral">Tagungen</Tab>
            {
              perm && (
                <Tab variant="soft" color="neutral">Administration</Tab>
              )
            }

          </TabList>







          <TabPanel sx={{ p: 0 }} value={2}>
            <Tabs
              aria-label="Vertical tabs"
              orientation="vertical"
              sx={{ minWidth: 300, height: "100vh" }}
              value={index}
              onChange={(event, value) => {

                setIndex(value)
              }}
            >
              <TabList>
                <Tab>Protokoll erstellen</Tab>
                <Tab>Beiratsprotokolle</Tab>
                <Tab>Tagungsprotokolle</Tab>
              </TabList>
              <TabPanel value={0}>

                <Card variant='soft'>
                  <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <Typography level="title-md">Protokoll Hinzufügen</Typography>
                    <Button onClick={() => navigate("/page-history/protokolle")}>Historie</Button>
                  </Box>

                  <Autocomplete value={selectedart} options={["Beirat", "Tagung"]} onChange={(e, newv) => setselectedart(newv)} placeholder='Kathegorie' />
                  <FormControl>
                    <FormLabel>Datum</FormLabel>
                    <Input
                      type="date"
                      value={datum ? new Date(datum).toISOString().split('T')[0] : ''}
                      onChange={(e) => {
                        const val = e.target.value;
                        setdatum(val ? new Date(val).getTime() : null);
                      }}
                    />
                  </FormControl>
                  <Autocomplete options={users?.result} getOptionLabel={(item) => item.name} onChange={(e, newv) => setselecteduser(newv)} placeholder='Ersteller' />
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: "10%" }}>
                    <Button
                      component="label"
                      variant="outlined"
                      color="primary"
                    >
                      Datei auswählen
                      <input
                        type="file"
                        hidden
                        onChange={handleFileChange}
                      />
                    </Button>

                    {file?.name && (
                      <Typography level="body-sm">
                        Ausgewählte Datei: <strong>{file.name}</strong>
                      </Typography>
                    )}
                  </Box>
                  <Button onClick={() => addDatei()} sx={{ width: "10%" }}>
                    Erstellen
                  </Button>
                </Card>
              </TabPanel>
              <TabPanel value={1}>
                {
                  editpanel && (
                    <Card sx={{ mb: 2 }}>
                      <Typography level="title-md">Protokoll bearbeiten</Typography>
                      <Autocomplete value={eidtkath} options={["Beirat", "Tagung"]} onChange={(e, newv) => seteditkath(newv)} placeholder='Kathegorie' />
                      <FormControl>
                        <FormLabel>Datum</FormLabel>
                        <Input
                          type="date"
                          value={editdatum ? new Date(editdatum).toISOString().split('T')[0] : ''}
                          onChange={(e) => {
                            const val = e.target.value;
                            seteditdatum(val ? new Date(val).getTime() : null);
                          }}
                        />
                      </FormControl>
                      <Autocomplete options={users?.result} value={editersteller} getOptionLabel={(item) => item.name} onChange={(e, newv) => seteditersteller(newv)} placeholder='Ersteller' />
                      <Button onClick={() => saveedit()} sx={{ width: "10%" }}>
                        Speichern
                      </Button>
                    </Card>
                  )
                }
                <Card variant='soft'>
                  <Typography level="title-md">Beiratsprotokolle</Typography>
                  <Table>
                    <thead>
                      <tr>
                        <th>Datum</th>
                        <th>Geschrieben von</th>
                        <th>Datei</th>
                        <th>Aktionen</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        data?.result?.slice().sort((a, b) => b.date - a.date).filter((a) => a.type == "Beirat").map((item) => {
                          return (
                            <tr key={item.id}>
                              <td>{item.displaydate.split(" ")[0]}</td>
                              <td>{item.writername}</td>
                              <td><Button onClick={() => window.open(
                                `${url}/api/filedownload/${item.objectid}/${item.filename}`,
                                "_blank",
                                "noopener,noreferrer"
                              )}>Download</Button></td>
                              <td>

                                <Dropdown>
                                  <MenuButton slots={{ root: IconButton }} slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}>
                                    <MoreVert />
                                  </MenuButton>
                                  <Menu>
                                    <MenuItem onClick={() => triggeredit(item.id, item.type, item.date, item.writerid)}>Bearbeiten</MenuItem>
                                    <MenuItem onClick={() => deleteprotokoll(item.id)} sx={{ color: "red" }}>Löschen</MenuItem>

                                  </Menu>
                                </Dropdown>


                              </td>
                            </tr>
                          )


                        })
                      }
                    </tbody>

                  </Table>
                </Card>
              </TabPanel>



              <TabPanel value={2}>
                {
                  editpanel && (
                    <Card sx={{ mb: 2 }}>
                      <Typography level="title-md">Protokoll bearbeiten</Typography>
                      <Autocomplete value={eidtkath} options={["Beirat", "Tagung"]} onChange={(e, newv) => seteditkath(newv)} placeholder='Kathegorie' />
                      <FormControl>
                        <FormLabel>Datum</FormLabel>
                        <Input
                          type="date"
                          value={editdatum ? new Date(editdatum).toISOString().split('T')[0] : ''}
                          onChange={(e) => {
                            const val = e.target.value;
                            seteditdatum(val ? new Date(val).getTime() : null);
                          }}
                        />
                      </FormControl>
                      <Autocomplete options={users?.result} value={editersteller} getOptionLabel={(item) => item.name} onChange={(e, newv) => seteditersteller(newv)} placeholder='Ersteller' />
                      <Button onClick={() => saveedit()} sx={{ width: "10%" }}>
                        Speichern
                      </Button>
                    </Card>
                  )
                }
                <Card variant='soft'>
                  <Typography level="title-md">Tagungsprotokolle</Typography>
                  <Table>
                    <thead>
                      <tr>
                        <th>Datum</th>
                        <th>Geschrieben von</th>
                        <th>Datei</th>
                        <th>Aktionen</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        data?.result?.slice().sort((a, b) => b.date - a.date).filter((a) => a.type == "Tagung").map((item) => {
                          return (
                            <tr key={item.id}>
                              <td>{item.displaydate.split(" ")[0]}</td>
                              <td>{item.writername}</td>
                              <td><Button onClick={() => window.open(
                                `${url}/api/filedownload/${item.objectid}/${item.filename}`,
                                "_blank",
                                "noopener,noreferrer"
                              )}>Download</Button></td>
                              <td>

                                <Dropdown>
                                  <MenuButton slots={{ root: IconButton }} slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}>
                                    <MoreVert />
                                  </MenuButton>
                                  <Menu>
                                    <MenuItem onClick={() => triggeredit(item.id)}>Bearbeiten</MenuItem>
                                    <MenuItem onClick={() => deleteprotokoll(item.id)} sx={{ color: "red" }}>Löschen</MenuItem>

                                  </Menu>
                                </Dropdown>


                              </td>
                            </tr>
                          )


                        })
                      }
                    </tbody>

                  </Table>
                </Card>
              </TabPanel>


            </Tabs>
          </TabPanel>
          <TabPanel value={1}>
            <Card variant='soft'>
              <Typography level="title-md">Tagungs Protokolle</Typography>
              <Table borderAxis="xBetween">
                <thead>
                  <tr>
                    <th>Monat</th>
                    <th>Januar</th>
                    <th>Februar</th>
                    <th>März</th>
                    <th>April</th>
                    <th>Mai</th>
                    <th>Juni</th>
                    <th>Juli</th>
                    <th>August</th>
                    <th>September</th>
                    <th>Oktober</th>
                    <th>November</th>
                    <th>Dezember</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>{new Date().getFullYear()}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(tagungslongarray, new Date().getFullYear(), month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 1}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(tagungslongarray, new Date().getFullYear() - 1, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 2}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(tagungslongarray, new Date().getFullYear() - 2, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 3}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(tagungslongarray, new Date().getFullYear() - 3, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 4}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(tagungslongarray, new Date().getFullYear() - 4, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 5}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(tagungslongarray, new Date().getFullYear() - 5, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                </tbody>
              </Table>
            </Card>
          </TabPanel>











          <TabPanel value={0}>
            <Card variant='soft'>
              <Typography level="title-md">Beirat Protokolle</Typography>
              <Table>
                <thead>
                  <tr>
                    <th>Monat</th>
                    <th>Januar</th>
                    <th>Februar</th>
                    <th>März</th>
                    <th>April</th>
                    <th>Mai</th>
                    <th>Juni</th>
                    <th>Juli</th>
                    <th>August</th>
                    <th>September</th>
                    <th>Oktober</th>
                    <th>November</th>
                    <th>Dezember</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>{new Date().getFullYear()}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(beiratlongarray, new Date().getFullYear(), month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 1}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(beiratlongarray, new Date().getFullYear() - 1, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 2}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(beiratlongarray, new Date().getFullYear() - 2, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 3}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(beiratlongarray, new Date().getFullYear() - 3, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 4}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(beiratlongarray, new Date().getFullYear() - 4, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th>{new Date().getFullYear() - 5}</th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <th key={month}>
                        {hasTimestampForMonth(beiratlongarray, new Date().getFullYear() - 5, month) ? (
                          <CheckCircleOutlinedIcon sx={{ color: "lightgreen" }} />
                        ) : (
                          <HighlightOffOutlinedIcon sx={{ color: "red" }} />
                        )}
                      </th>
                    ))}
                  </tr>
                </tbody>
              </Table>
            </Card>
          </TabPanel>
        </Tabs>





      </div >
      <NavigationBar state="home" back="none" />
    </>
  )
}

export default Protokolle
